import { Close } from '../icons';
import { FunctionComponent } from "react";
import { Button, IconButton, Input } from '../../tailwindcomponents';

type TailAndIssueSearchProps = {
    setSearchTail: Function,
    setSearchIssue: Function,
    getHandoversBySearch: Function,
    refreshHandOverTab: Function,
    searchTail: string,
    searchIssue: string,
}

const SearchTailAndIssue: FunctionComponent<TailAndIssueSearchProps> = ({ searchIssue, searchTail, setSearchTail, setSearchIssue, getHandoversBySearch, refreshHandOverTab }) => {
    return (
        <div className="ds-filter-bar">
            <Input
                multiline={false}
                label_text="Search by tail"
                value={searchTail}
                help_text=""
                onTextChange={(value: string) => setSearchTail(value)}
                type="text"
                width={25}
                icon={<IconButton onClick={() => setSearchTail("")}><Close /> </IconButton>}
                iconPlacement="end"
            />
            <Input
                multiline={false}
                label_text="Search by issue"
                value={searchIssue}
                help_text=""
                onTextChange={(value: string) => { setSearchIssue(value); }}
                type="text"
                width={25}
                icon={<IconButton onClick={() => setSearchIssue("")}><Close /> </IconButton>}
                iconPlacement="end"
            />
            <div className="ds-filter-actions">
                <Button variant="text" onClick={() => getHandoversBySearch()} color='primary'>Filter</Button>
                <Button variant="text" onClick={() => { refreshHandOverTab(); setSearchIssue(""); setSearchTail(""); }} color='primary'>Clear Filters</Button>
            </div>
        </div>
    )
}

export default SearchTailAndIssue;